export class Maestro_Ciudades_Ubicacion {
    codigo: string;
    provincia: string;
    cobertura: string;
    listaPoligono: google.maps.LatLngLiteral[];
    opcionesPoligono: google.maps.PolygonOptions = {}
}